<template>
    <div>
        <tsoft-table
            :name="'competitor'"
            :api="tableApiUrl"
            :items.sync="items"
            :isNeedSearch="false"
            :isNeedSelection="false"
            :isNeedCreate="false"
            :headerContextMenuName="'competitorTable'"
            @show="showItem"
            @edit="createOrEditItemModal"
            @delete="deleteItem"
            :customAddButtonName="'Добавить'"
        />
        <!-- :typeOfTableFilter="'competitor'" -->
    </div>
</template>

<script>
    import { API_COMPETITORS } from '@/constants';

    import {
        defaultDataItems,
        actionShowItem,
        actionCreateOrUpdateItem,
        actionDeleteItem,
    } from '@/mixins';
    import { openCompanySidebar } from '@/mixins/openCompanySidebar';

    const initialEditedItem = () => ({
        id: '',
        license_number: '',
        name: '',
        inn: '',
        address: '',
        size: '',
        taked: 'Нет'
    })

    export default {
        mixins: [
            defaultDataItems,
            actionShowItem,
            actionCreateOrUpdateItem,
            actionDeleteItem,
            openCompanySidebar,
        ],
        data() {
            return {
                model_name: ['App\\Models\\Competitor'],
                changeLoad: false,
                isSideBarOpenCompany: false,
                isSideBarOpenPaymentDetails: false,
                tableApiUrl: API_COMPETITORS,
                reloadComponent: 0
            }
        },
        mounted() {
            this.editedItem = initialEditedItem()
        },
        methods: {
            // calls from mixin on show sidebar company
            onOpenCompanyModalCallback() {
                this.isSideBarOpenCompany = true
            },
            setClosedSidePanelCompany(){
                this.editedItem = initialEditedItem()
                this.editIndex = -1
            },
        }
    }
</script>
